import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'
import { BlogState } from '../store/blog/blogReducer'
import { BlogPostState } from '../store/blogPost/blogPostReducer'

export const getBlogData = (pageId: number) => {
  return monolithHttpClient.get<BlogState>(`/pages/${pageId}/blog/data`)
}

export const getBlogPostData = (pageId: number) => {
  return monolithHttpClient.get<BlogPostState>(
    `/pages/${pageId}/blog-post/data`,
  )
}
